/* eslint-disable */
import { useState } from "react";
import { Box, Button, Fade, Modal, Typography } from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";
import { ImportRawHtmlPopupStyle } from "./css";

function ImportRawHtmlPopup({ open, handleClose, onImport }) {
  const [html, setHtml] = useState("");
  return (
    <Modal open={open} closeAfterTransition>
      <Fade in={open}>
        <ImportRawHtmlPopupStyle>
          <Button className="closeBtn" onClick={handleClose}>
            <CancelIcon />
          </Button>
          <Box className="BodyContentWrapper">
            <Typography component="h2">Enter raw HTML to import into the editor. It will replace the existing content.</Typography>
            <textarea placeholder="HTML code" value={html} onChange={e => setHtml(e.target.value)} />
            <Box className="BtnWrapper">
              <Button onClick={() => {
                if (!html.trim()) return;
                onImport(html);
                setHtml("");
                handleClose();
              }}>OK</Button>
            </Box>
          </Box>
        </ImportRawHtmlPopupStyle>
      </Fade>
    </Modal>
  );
}

export default ImportRawHtmlPopup;
